import React from 'react';
import cn from 'classnames';
import { Icon } from '../../../Icon';
import "./styles.css";
export var NavigationIcon = function (_a) {
    var customClassName = _a.className, direction = _a.direction, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var className = cn('lk-ui_calendar_icon', customClassName, {
        disabled: disabled,
    });
    var onClickHandler = !disabled ? onClick : undefined;
    return (React.createElement(Icon, { iconName: direction, className: className, onClick: onClickHandler, size: 'large' }));
};
